import { useForm } from "react-hook-form";
import { FC, useContext, useEffect } from "react";

import { contextType, FamilyHistoryContext } from "./FamilyHistory";
import { Button, CircularProgress } from "@mui/material";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import { socialHistoryForm } from "./fieldData";
import { useMutation } from "react-query";
import {
  addFamilyHistory,
  getfamilyIcdDetails,
  getPatientRelation,
} from "../../../services";
import { clinicId } from "../../../../constants";
import { useParams } from "react-router-dom";
import { getFamilyHistory, PostFamilyHistoryType } from "./type";
import usePopup from "../../../../hooks/usePopup";
import { HL7ContexTriggerContex } from "../../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import moment from "moment";
import useAuthentication from "@hooks/useAuthentication";
import { EmrContext } from "../../../index";

const FamilyHistoryForm: FC<{ close?: () => void }> = ({ close }) => {
  const {setTrigger,trigger} = useContext(HL7ContexTriggerContex)
  const {showSnackbar} = usePopup()
  const {user} = useAuthentication()
  const { handleSubmit, control, reset, setValue } = useForm();
  const { edit, setEdit, setSuccess } = useContext(
    FamilyHistoryContext
  ) as contextType;
  const { triggerConsultationStart } = useContext(EmrContext);
  const { encounterId, patientId } = useParams();
  const { mutate: saveData,isLoading:saveLoading } = useMutation(addFamilyHistory, {
    onSuccess: (result) => {
      setSuccess((prev: boolean) => !prev);
      if(result.responseIndicator == "success"){
        showSnackbar({
          message:result.responseMessage,
          open:true,
          variant:"success",
          duration:2000
        })
        setTrigger({
           ...trigger,
           encounterId:encounterId as string,
           tab:"familyhistory"
        })
        triggerConsultationStart();
      }else{
        showSnackbar({
          message:result.responseMessage,
          open:true,
          variant:"warning",
          duration:2000
        })
      }
    },
    onError:()=>{
      showSnackbar({
        message:"something went wrong",
        open:true,
        variant:"warning",
        duration:2000
      })
    }
  });
  const { mutate: getIcdetails, data: icdData } =
    useMutation(getfamilyIcdDetails);
  const { mutate: getRelation, data: PatientRelation } =
    useMutation(getPatientRelation);


  const prepareFamilyHistory = (
    data: getFamilyHistory
  ): PostFamilyHistoryType => {
    return {
      pfshId: data?.id || null,
      encounterId: parseInt(encounterId as string),
      icdId: data.icd.icdId,
      pfshFamilyRelation: data.relation.id,
      pfshFamilyHistory: `${data.relation.description}:${data.icd.icdCode}`,
      pfshStatus: 1,
      pfshIp: 1,
      pfshCreatedId: String(user?.userId) || null,
      pfshCreatedDate: null,
      pfshClinicId: clinicId,
      revertFlag: false,
      notes: data.notes || null,
      fromDate: data.fromdate ? moment(data.fromdate).format("YYYY-MM-DD") : null,
      toDate: data.todate ? moment(data.todate).format("YYYY-MM-DD") : null,
      patientId: parseInt(patientId as string),
      hl7MsgStatus: 0,
    };
  };
  const onsubmit = (data: any) => {
    const FamilyHistoryData = prepareFamilyHistory(data);
    let dateCheck = true
    if(FamilyHistoryData?.fromDate && FamilyHistoryData?.toDate){
      dateCheck = moment(FamilyHistoryData.fromDate,"YYYY-MM-DD").isSameOrBefore(moment(FamilyHistoryData.toDate,"YYYY-MM-DD"),"day")
    }
    if(dateCheck){
      if (Boolean(edit)) {
        setEdit(null);
        saveData(FamilyHistoryData);
      } else {
        reset();
        saveData(FamilyHistoryData);
      }
    }else{
      showSnackbar({
        message:"Invalid TO DATE !",
        open:true,
        variant:"warning",
        duration:2000
      })
    }
   
  };
  useEffect(() => {
    if (Boolean(edit)) {
      reset({ ...edit,[socialHistoryForm.description.name]:edit?.icd.icdDescription });
    } else {
      reset({
        icdCode: null,
        relation: null,
        Description: null,
        fromdate: null,
        todate: null,
        notes: "",
      });
    }
  }, [edit]);

  useEffect(() => {
    getIcdetails("");
    getRelation();

  }, []);
  return (
    <div className="gap-5 m-2">
      <form onSubmit={handleSubmit(onsubmit)}>
        <div className="grid grid-cols-6 gap-3">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              options={icdData?.response}
              {...socialHistoryForm.icdCode}
              fieldProps={{
                ...socialHistoryForm.icdCode.fieldProps,
                onChange: (e) => {
                  getIcdetails(e.target.value);
                },
              }}
              rules={{
                ...socialHistoryForm.icdCode.rules,
                onChange: (data) => {
                  setValue(socialHistoryForm.description.name, data.target.value.icdName);
                },
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              options={PatientRelation?.response}
              {...socialHistoryForm.relation}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...socialHistoryForm.description}
            />
          </div>
          <div className="col-span-1">
            <CustomFormField
              control={control}
              {...socialHistoryForm.fromdate}
              
            />
          </div>
          <div className="col-span-1">
            <CustomFormField control={control}
             {...socialHistoryForm.todate}
             />
          </div>

          <div className="col-span-2">
            <CustomFormField control={control} {...socialHistoryForm.notes} />
          </div>
          <div className="col-span-2 flex flex-row items-center justify-end gap-2">
            <Button type="submit" color="success" disabled={saveLoading} endIcon={saveLoading && <CircularProgress size={18} />}>
              Save
            </Button>
            <Button
              color="error"
              onClick={() => {
                close && close();
              }}
            >
              {" "}
              cancel{" "}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FamilyHistoryForm;
